<div *ngIf="showFeaturedPlaylist" [ngClass]="styles.wrapper" layout="row">
	<div [ngClass]="styles.item" layout="row" flex="fill">
		<vb-ui-checkbox name="isFeaturedPlaylistSelected" [ngClass]="styles.chkBox" [(ngModel)]="featuredPlaylist.isSelected">
		</vb-ui-checkbox>
		<span flex="fill">
			{{ 'Media_Videos_Playlists_FeaturedVideos' | translate }} - ({{ featuredPlaylist.videoIds.length }})<br/>
			<small>
				{{ 'Media_Videos_Playlists_DateModified' | translate }}: {{ featuredPlaylist.date | vbDateTimeMedium }}
			</small>
		</span>
	</div>
</div>

<div *ngFor="let playlist of userPlaylists" [ngClass]="styles.wrapper">
	<div [ngClass]="styles.item" [hidden]="playlist.editMode" layout="row">
		<vb-ui-checkbox name="isPlaylistSelected" [ngClass]="styles.chkBox" [(ngModel)]="playlist.isSelected">
		</vb-ui-checkbox>
		<span flex="1 1 0" [ngClass]="styles.title">
			{{ playlist.name }} - ({{ playlist.videoIds.length }})
			<br/>
			<small>
				{{ 'Media_Videos_Playlists_DateModified' | translate }}: {{ playlist.date | vbDateTimeMedium }}
			</small>
		</span>
		<button *ngIf="playlist.name" type="button" [ngClass]="styles.editBtn" [attr.aria-label]="'Media_Videos_Playlists_Edit' | translate" (click)="playlist.editMode = true" vbUiBtnPrimaryNgx>
			<span [ngClass]="styles.phoneLogo" class="glyphicons pencil"></span>
		</button>
	</div>
	<add-playlist [hidden]="!playlist.editMode" flex="1 1 0" [playlist]="playlist" [isCreatingPlaylist]="playlist.isUpdateInProgress" (onCreatePlaylist)="updatePlaylist($event)" (onCancelCreatePlaylist)="playlist.editMode = false">
	</add-playlist>
</div>

<div [hidden]="!(showFeaturedPlaylist || userPlaylists.length)" class="margin-top-10 padding-bottom-10" layout="row" flex-justify="end">
	<button type="button" class="margin-right-10" (click)="onCancel()" vbUiBtnSecondaryNgx>
		{{ 'Cancel' | translate }}
	</button>
	<button type="button" class="margin-right-10" (click)="savePlaylists()" vbUiBtnPrimaryNgx>
		<span [hidden]="isPlaylistSaving">
			{{ 'Save' | translate }}
		</span>
		<span [hidden]="!isPlaylistSaving">
			<vb-loading-spinner [size]="'small'"></vb-loading-spinner>
			{{ 'Media_Videos_Playlists_Saving' | translate }}
		</span>
	</button>
</div>